import { render, staticRenderFns } from "./IIDIED.vue?vue&type=template&id=b9b25c28&scoped=true&"
import script from "./IIDIED.vue?vue&type=script&lang=js&"
export * from "./IIDIED.vue?vue&type=script&lang=js&"
import style0 from "./IIDIED.vue?vue&type=style&index=0&id=b9b25c28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b25c28",
  null
  
)

export default component.exports